function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#555555;stroke:#555555;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;stroke:#555555;stroke-width:3;stroke-miterlimit:10;}\n\t.st2{fill:#BADADA;}\n\t.st3{fill:#1F3642;}\n\t.st4{fill:#E89A4F;}\n\t.st5{fill:#EBEBEB;}\n\t.st6{display:none;}\n\t.st7{display:inline;fill:#FFFFFF;stroke:#555555;stroke-miterlimit:10;}\n\t.st8{display:inline;fill:#E89A4F;}\n\t.st9{display:inline;fill:#1F3642;}\n\t.st10{display:inline;opacity:0.2;enable-background:new    ;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "a5a3b5e3-d7d8-4dd0-99da-2c47698acbff"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M715.2,303.7h-414c-1.8,0-3.3-1.5-3.3-3.3V3.3c0-1.8,1.5-3.3,3.3-3.3h414c1.8,0,3.3,1.5,3.3,3.3v297.2 C718.5,302.3,717,303.7,715.2,303.7z M301.2,2c-0.7,0-1.3,0.6-1.3,1.3v297.2c0,0.7,0.6,1.3,1.3,1.3h414c0.7,0,1.3-0.6,1.3-1.3V3.3 c0-0.7-0.6-1.3-1.3-1.3H301.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M692.4,25.5v211.2c0,2.9-2.4,5.3-5.3,5.3l0,0H328.5c-0.3,0-0.5,0-0.8-0.1c-2.6-0.4-4.6-2.6-4.6-5.3V25.5 c0-2.9,2.4-5.3,5.3-5.3H687C690,20.2,692.4,22.6,692.4,25.5L692.4,25.5L692.4,25.5z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 311.2,
  cy: 292.1,
  r: 6.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 311.2,
  cy: 12.1,
  r: 6.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 706.2,
  cy: 12.1,
  r: 6.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 706.2,
  cy: 292.1,
  r: 6.4
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "220.8,506.8 233,506.8 238.9,459.5 220.8,459.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M256.7,518.1h-38.5l0,0v-14.9l0,0h23.6C250,503.3,256.7,509.9,256.7,518.1L256.7,518.1L256.7,518.1z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "174.8,506.8 187,506.8 192.9,459.5 174.8,459.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M210.7,518.1h-38.5l0,0v-14.9l0,0h23.6C204,503.3,210.7,509.9,210.7,518.1L210.7,518.1L210.7,518.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M176.3,365.9c5-3.2,6.4-9.9,3.2-14.8c-0.3-0.5-0.7-1-1.2-1.5l8.1-114.6l-23.3,2.3l-0.6,112.2 c-4.1,4.3-3.9,11.2,0.4,15.3C166.6,368.2,172.1,368.7,176.3,365.9L176.3,365.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M221.1,482.9c-2.3,0-4.2-1.7-4.5-4l-7.1-59.6c-0.2-1.9-2-3.3-3.9-3.1c-1.6,0.2-2.8,1.4-3,2.9l-9,57.1 c-0.3,2.2-2.2,3.8-4.4,3.8h-14.6c-2.5,0-4.5-2-4.5-4.5l0,0L177,349c0-2.2,1.6-4.1,3.9-4.4l54-7.8c2.5-0.4,4.7,1.3,5.1,3.8 c0,0.2,0,0.4,0,0.7l-0.9,136.6c0,2.4-1.9,4.3-4.3,4.5l-13.5,0.6C221.3,482.9,221.2,482.9,221.1,482.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M193.2,353.8c-5.2,0-10.3-0.9-15.2-2.7c-1.7-0.6-2.8-2.2-2.9-4c-0.5-10.3-3.2-63.5-11.1-96 c-3.2-13,1.8-26.7,12.6-34.6c0.4-0.3,0.9-0.6,1.3-0.9c9.3-6.2,21.2-7.1,31.4-2.5c10.5,4.7,17.8,14.5,19.4,26l12.9,96.1 c0.2,1.2-0.2,2.4-0.9,3.4s-1.8,1.6-3.1,1.7c-4.5,0.4-13.8,2.2-25.7,8.8C206.1,352.2,199.7,353.9,193.2,353.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M177.3,274.2l-21.3-5.8c-2.4-0.7-3.8-3.1-3.2-5.5l7.5-27.6c1.8-6.6,8.6-10.5,15.2-8.7 c5.6,1.5,9.5,6.8,9.1,12.6l-1.7,30.9c-0.1,2.5-2.3,4.4-4.7,4.2C178,274.3,177.6,274.3,177.3,274.2z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 201,
  cy: 175.6,
  r: 24.6
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M290,223.8c-0.1,0.5-0.2,1.1-0.2,1.6l-43,24.8l-10.4-6l-11.1,14.6l22.3,15.9l49-38.7c5.4,2,11.5-0.8,13.5-6.2 s-0.8-11.5-6.2-13.5c-5.4-2-11.5,0.8-13.5,6.2C290.3,223,290.1,223.4,290,223.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M243.3,251.4l-18.5,12c-2.1,1.3-4.9,0.8-6.2-1.3l-15.6-24c-3.7-5.7-2.1-13.4,3.7-17.2 c4.9-3.2,11.4-2.5,15.5,1.6l21.9,21.9c1.8,1.8,1.8,4.6,0,6.4C243.8,251.1,243.5,251.3,243.3,251.4L243.3,251.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M183.7,195c4.6,4.9,13.1,2.3,13.7-4.4c0-0.5,0-1,0-1.6c-0.3-3-2-5.6-1.6-8.8c0.1-0.8,0.4-1.5,0.8-2.1 c3.7-4.9,12.2,2.2,15.7-2.2c2.1-2.7-0.4-7,1.3-10c2.1-4,8.5-2,12.5-4.2c4.4-2.4,4.2-9.2,1.2-13.4c-3.6-5-9.8-7.7-15.9-8.1 s-12.3,1.3-18,3.5c-6.5,2.5-13,6.1-17,11.8c-4.9,7-5.3,16.3-2.9,24.5C174.8,185,179.9,191,183.7,195z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M382,519.9H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h381c0.6,0,1,0.4,1,1S382.6,519.9,382,519.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1008,519.9H627c-0.6,0-1-0.4-1-1s0.4-1,1-1h381c0.6,0,1,0.4,1,1S1008.6,519.9,1008,519.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M835.4,331.3c-5.1-2.5-7.2-8.8-4.7-13.9c0.3-0.5,0.6-1.1,1-1.6l-7.7-75.6h16.7l6.1,73.8 c4.4,3.7,4.9,10.3,1.2,14.7C844.9,332.4,839.7,333.5,835.4,331.3L835.4,331.3z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 820.1,
  cy: 174.9,
  r: 23.6
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M814.7,284.2l-35.3-7.7c-1.9-0.4-3.3-2.1-3.4-4c-0.4-7.9-0.7-28.2,5.4-47.3c4.8-15.1,21-23.3,36-18.5 c0.3,0.1,0.5,0.2,0.8,0.3l0,0c14.9,5.2,22.8,21.6,17.5,36.5c-0.4,1-0.8,2-1.3,3c-7.8,16.1-12.8,27.7-14.6,34.6 C819.2,283.3,816.9,284.7,814.7,284.2L814.7,284.2z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "781.5,508.8 769.7,508.8 764,463.3 781.5,463.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M761.2,505.5H784l0,0v14.3l0,0h-37.1l0,0l0,0C746.9,511.9,753.3,505.5,761.2,505.5L761.2,505.5z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "899.5,493.5 889.1,499.2 862.3,462 877.5,453.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M880.1,500.3l19.9-11l0,0l6.9,12.6l0,0l-32.5,17.9l0,0l0,0C870.7,512.8,873.2,504.1,880.1,500.3L880.1,500.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M781.7,483.5l-18.2-1.4c-2.1-0.2-3.8-1.8-4-3.9c-2.6-27-14-163.9,16.8-206l0.1-0.1l0.1-0.1 c0.3-0.1,27.7-9.9,43.4,8c1,1.2,1.3,2.8,0.8,4.2l-0.6,1.8c-0.3,1-0.2,2.2,0.5,3.1c4.4,5.9,19,28.6,24.8,73.3c0,0.3,0.1,0.6,0.2,0.8 L888.3,468c0.9,2.2-0.2,4.7-2.4,5.6h-0.1l-13.4,5.1c-2,0.8-4.3-0.1-5.3-2l-61.5-111.6c-0.6-1.2-2.1-1.6-3.3-0.9 c-0.7,0.4-1.1,1-1.2,1.8l-14.8,113.7c-0.3,2.2-2.1,3.8-4.3,3.8C781.9,483.6,781.8,483.6,781.7,483.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M728.2,202.4c0.1,0.5,0.2,1,0.2,1.6l41.4,23.9l10.1-5.8l10.7,14l-16.8,12c-2.8,2-6.6,1.9-9.2-0.2L722,214.3 c-5.2,1.9-11-0.7-13-6c-1.9-5.2,0.7-11,6-13c5.2-1.9,11,0.7,13,6C727.9,201.5,728.1,201.9,728.2,202.4L728.2,202.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M770.3,225.4c0.3-1.2,1-2.3,2.1-2.9l19-10.6c5.3-4.1,12.8-3.1,16.9,2.2c4,5.2,3.1,12.8-2.1,16.8L791,246.6 c-1.7,1.7-4.4,1.8-6.1,0.1c-0.2-0.1-0.3-0.3-0.4-0.5l-13.4-17.3C770.4,227.9,770.1,226.6,770.3,225.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M819.4,258.1c-1-0.8-1.6-2-1.6-3.2l-0.7-21.7c-1.2-6.5,3.2-12.8,9.7-14s12.8,3.1,14,9.6l7,20.7 c0.8,2.3-0.5,4.7-2.7,5.5c-0.2,0.1-0.4,0.1-0.6,0.2l-21.5,3.9C821.7,259.2,820.4,258.9,819.4,258.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M816.3,169.4c-6.1,4.2-14.1,8.4-20.3,4c-4-3-5.5-8.3-3.7-13c3-8.5,11.1-12.2,18.9-15.1 c10.2-3.7,21.2-6.7,31.7-4s19.7,12.8,17.8,23.5c-1.5,8.6-9.6,15.7-8.5,24.3c1.2,8.7,10.9,13.2,19.5,14.8s18.3,2,24.4,8.2 c7.9,7.9,5.9,22-1.5,30.3s-18.6,12.1-29.5,14.7c-14.4,3.4-30,5.2-43.6-0.5s-24.3-20.8-20.4-35.1c1.7-6,5.6-11.1,9.4-16.1 s7.7-10.1,9.1-16.2c1.2-5.1,0.3-10.9-3-14.7c-1.3-1.4-1.5-3.4-0.6-5L816.3,169.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M419.4,101.7c4.6-4.4,9.7-8.1,12.8-10.1c18.5-11.8,39.5-19.8,61.7-18.3c9.3,0.6,19.1,2,27.4,6.3 c7.9,4,11.4,10.5,12.5,19c1.6,12-10.1,10.8-18.1,14c-5.8,2.4-6.1,5.8-8.3,10.8c-4.2,9.2-12,15.6-21.6,18.5 c-8.8,2.6-20.2,5.7-28.5,0.1c-7.3-4.9-15.3-8.1-24-9.4c-5.6-0.8-11.1-0.8-16.4-3.3C402.7,122.4,410.1,110.6,419.4,101.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M435.9,140.5c7.5-4.8,16.1-9,22.1-15.7c3.2-3.6,9.3-8.9,13.7-4.1c1.8,1.9,2.6,4.7,4.2,6.8 c4.1,5.5,10.8,8.4,15.8,12.9c5.6,5.1,10.8,10.9,14.6,17.6c0,0,6.6,13.3-11.6,23.1c-3.8,2.1-7.5,5.5-9.8,9.3c-1,1.7-1.7,3.3-3.2,4.6 c-4.7,4.4-13.4,5.5-19.2,3.7c-6-1.8-11.8-4.4-17.4-7.2c-3.6-1.8-7.5-3.4-10.6-6c-6.5-5.5-10-14.2-11.8-22.4 c-1-4.7-2.2-10.2-0.8-14.9C423.8,141.8,431.1,143.6,435.9,140.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M498.5,146.4c18.3-18.6,39.1-34.3,60.9-34.6c5.6-0.1,11.4,1,16.2,4.8c4.8,3.8,8.5,10.8,8.6,18.8 c0.1,6.2-1.9,12.7-0.4,18.4c0.7,2.7,2.1,4.8,3.2,7.1c5.6,11.6,3.6,29.5-4.3,39.3c-7.8,9.6-18.9,10.4-28.9,9.8 c-9.5-0.5-19.1-1.9-27.7-7.1c-4.9-3-9.4-7.2-14.5-9.6c-4.8-2.3-10.1-2.8-14.9-4.9c-8.7-3.7-15.9-15-9.4-28.1 c2.2-4.5,5.3-7.9,8.4-11.1C496.6,148.3,497.6,147.4,498.5,146.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M566.8,86.2c0.8,1.4,1.4,3,2,4.4c2.4,6.2,6.3,14.7,5.2,21.6c0,0,1,15-12.3,14.5c-22.2-0.9-47.4-10-59.6-29.8 c-4.4-7.2-3.5-14.1,3.9-18.5c7.4-4.4,19.6-8.3,28.2-7.7c3.7,0.2,6.9,1.6,9.5,4.2c3,3,5.3,8,10,8.3c2.9,0.2,6.5-1,9.3-0.1 C564.8,83.6,565.9,84.7,566.8,86.2z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "\\u5716\\u5C64_2",
  className: "st6"
}, /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M49.3,507c18.4,13.2,42.1,13.9,65.1,12.3c3.2-0.2,6.4-0.5,9.6-0.8c0,0,0,0,0.1,0c0.2,0,0.3,0,0.4,0 c0.7-0.1,1.3-0.1,1.9-0.2l-0.2,0.3l-0.5,0.9c0.2-0.3,0.3-0.6,0.5-0.9c0.1-0.1,0.1-0.2,0.2-0.3c6-10.4,11.9-21.1,13.4-32.9 c1.6-12.3-2.8-26.2-13.6-32.2c-1.4-0.8-2.9-1.4-4.5-1.9c-0.6-0.2-1.3-0.4-2-0.5c-12.6-2.8-25.1,5.2-27.9,17.8 c-0.9,4.2-0.7,8.6,0.7,12.6c-9.2-9.4-7.5-24.6-4.3-37.4c3.2-12.7,7-26.9,0.6-38.4c-3.6-6.4-9.9-10.3-16.9-11.9 c-0.2,0-0.4-0.1-0.7-0.1c-8.4-1.7-17.2-0.2-24.5,4.3c-13.5,8.5-20.5,24.7-22.7,40.5C20.4,463.6,28.4,492,49.3,507z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M55.2,466.2c0.5,5.6,1.9,11.1,4,16.3c2,4.6,4.6,8.9,7.8,12.8c6.7,7.9,15.2,14,24.8,17.9c7.2,3,14.8,5,22.6,6.1 c3.2-0.2,6.4-0.5,9.6-0.8c0,0,0,0,0.1,0c0.2,0,0.3,0,0.4,0c0.7-0.1,1.3-0.1,1.9-0.2l-0.2,0.3l-0.5,0.9c0.2-0.3,0.3-0.6,0.5-0.9 c0.1-0.1,0.1-0.2,0.2-0.3c-11.8-11.8-17.2-28.5-14.4-44.9c1.4-8,4.7-15.6,9.7-22.1c-0.6-0.2-1.3-0.4-2-0.5 c-1.9,2.6-3.5,5.3-4.9,8.1c-5,10.1-6.6,21.6-4.5,32.7c1.9,10.1,6.6,19.4,13.6,26.8c-0.6,0-1.2-0.1-1.8-0.1 c-11.5-1-22.9-3.4-33.3-8.5c-8.9-4.2-16.6-10.6-22.5-18.5c-6.3-8.7-9.1-19.1-9.6-29.8c-0.4-11.4,0.8-22.9,3.6-34 c2.7-11.3,6.7-22.3,12-32.7c0.2-0.5,0.1-1.1-0.4-1.4c-0.2-0.1-0.4-0.2-0.7-0.1c-0.2,0.1-0.4,0.2-0.5,0.4c-0.7,1.3-1.3,2.6-1.9,3.9 c-5.2,10.8-9,22.2-11.3,33.9C55.2,442.8,54,454.7,55.2,466.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M975.4,498.8c-27.7,19.9-63.6,20.9-98.3,18.5c-4.8-0.3-9.7-0.7-14.4-1.2h-0.1c-0.2,0-0.5,0-0.7-0.1 c-1-0.1-2-0.2-2.9-0.3l0.2,0.4l0.7,1.4c-0.3-0.5-0.5-0.9-0.8-1.4c-0.1-0.1-0.2-0.3-0.2-0.4c-9-15.6-17.9-31.8-20.2-49.7 c-2.3-18.5,4.3-39.5,20.6-48.6c2.1-1.2,4.4-2.1,6.8-2.8c1-0.3,2-0.5,3-0.7c19-4.2,37.9,7.8,42.1,26.8c1.4,6.3,1,12.9-1.1,19.1 c13.8-14.2,11.2-37.2,6.5-56.4c-4.8-19.2-10.6-40.6-0.8-57.9c5.4-9.6,14.9-15.6,25.6-18c0.3-0.1,0.7-0.1,1-0.2 c12.7-2.6,25.9-0.3,37,6.5c20.4,12.8,30.9,37.2,34.3,61.1C1019,433.3,1006.9,476.2,975.4,498.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M966.5,437.3c-0.8,8.5-2.8,16.8-6,24.7c-3,7-6.9,13.5-11.8,19.3c-10,12-23.1,21-37.4,27 c-10.9,4.5-22.4,7.6-34.1,9.2c-4.8-0.3-9.7-0.7-14.4-1.2h-0.1c-0.2,0-0.5,0-0.7-0.1c-1-0.1-2-0.2-2.9-0.3l0.2,0.4l0.7,1.4 c-0.3-0.5-0.5-0.9-0.8-1.4c-0.1-0.1-0.2-0.3-0.2-0.4c17.8-17.7,25.9-43,21.7-67.8c-2.2-12.1-7.1-23.6-14.6-33.4c1-0.3,2-0.5,3-0.7 c2.8,3.9,5.3,7.9,7.4,12.2c7.5,15.3,9.9,32.6,6.8,49.4c-2.9,15.2-10,29.2-20.6,40.5c0.9-0.1,1.9-0.1,2.8-0.2 c17.3-1.5,34.6-5.2,50.3-12.8c13.4-6.4,25.1-15.9,33.9-27.8c9.5-13.1,13.7-28.9,14.4-44.9c0.8-17.2-1.5-34.6-5.4-51.3 c-4-17.1-10.1-33.7-18.1-49.3c-0.4-0.7-0.1-1.6,0.6-2c0.3-0.2,0.6-0.3,1-0.2c0.3,0.1,0.6,0.3,0.8,0.6c1,1.9,2,3.9,2.9,5.8 c7.8,16.3,13.5,33.5,17.1,51.2C966.4,402,968.3,419.9,966.5,437.3z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 413.6,
  cy: 99.1,
  r: 46.6
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M559.9,242.9H331c-0.3,0-0.6,0-0.9-0.1L438.4,55.3c2.1-3.6,6.7-4.9,10.3-2.9c1.2,0.7,2.2,1.7,2.9,2.9 l72.6,125.8l3.5,6L559.9,242.9z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st10",
  points: "559.9,242.9 481.7,242.9 520.1,187.2 522.8,183.2 524.2,181.2 527.7,187.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M687.3,242.9H489.4l38.4-55.7l2.8-4l50-72.6c3.3-4.8,11.2-5.1,15-0.9c0.3,0.3,0.5,0.6,0.7,0.9L687.3,242.9z"
}));

function SvgDraw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1014.8 519.9",
    style: {
      enableBackground: "new 0 0 1014.8 519.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraw);
export default __webpack_public_path__ + "static/media/draw.5867cf7c.svg";
export { ForwardRef as ReactComponent };